import React from "react";
import axios from "axios";
import Footer from "./partial/Footer";
import Query from "./Cmpnt/Query_sec";
import Contact_form from "./Contact_form";
import Contact_left from "./Contact";

import Contacttop_bg from "./Contact_topbg";  
import { cmsdetail } from "./Api_list";
import { Helmet } from "react-helmet";

const Advisory_board = () => {
    const [ post, setPost ] = React.useState( null );
    React.useEffect(()=>{
        var headerData = {"headers":{
            "Accept": "application/json",
            "Content-Type": "application/json",
            "authorization": window.HEADERSAUTH,
          }}  
        axios.get(cmsdetail+'contact-us', headerData).then(( response )=>{
            setPost( response.data );
        }) 
    }, []) 
    if( !post ) return null;
    let getData = post.data;
    return (
        <>
        <Helmet>
            <title>{(getData != null) ? getData.meta_title : 'Careereduversity'}</title> 
            <meta name="title" content={(getData != null) ? getData.meta_title : 'Careereduversity'} />
            <meta name="description" content={(getData != null) ? getData.meta_description : 'Careereduversity'} />
            <meta name="keywords" content={(getData != null) ? getData.meta_keyword : 'Careereduversity'} />
            <meta property="og:title" content={(getData != null) ? getData.meta_title : 'Careereduversity'} />
            <meta property="og:image" content={(getData != null) ?  window.IMGURL + getData.image : 'Careereduversity'}/>
            <meta property="og:description" content={(getData != null) ? getData.meta_description : 'Careereduversity'} />
            <meta property="og:url" content={window.APPURL} />
        </Helmet>
        <Contacttop_bg/>
            <div className='container padd_30'>
                <div className="row centr_hdng_txt">
                    <h2 className="sitehdng"> Get In Touch With Us </h2>
                </div>
                <div className='row align-items-center'>
                    <div className='col-sm-6'>
                        <Contact_left /> 
                    </div>
                    <div className='col-sm-6'>
                        <Contact_form />
                    </div>
                </div>
            </div>
            <Query />
            <Footer />


        </>
    )
}

export default Advisory_board;
